export default __webpack_public_path__ + "static/media/pen-white.b919ec1c.svg";